import { HiX } from "react-icons/hi";

import { Modal } from "MVVM/Components/Wrappers/Existing/modal";

import { ESaveClipStep } from "./@types";
import {
  ModalContainer,
  ModalHeader,
  HeaderContent,
  HeaderTitle,
  ClipName,
  HeaderSubtitle,
  CloseButton,
} from "./styledComponents";
import { Checking } from "./Steps/Checking";
import { Summary } from "./Steps/Summary";
import { Success } from "./Steps/Success";
import { NoStorage } from "./Steps/NoStorage";
import { DeleteBrowse } from "./Steps/DeleteBrowse";
import { useSaveClipFlowViewModel } from "./ViewModel";

const SUBSCRIPTION_OVERHAUL =
  process.env.REACT_APP_SUBSCRIPTION_OVERHAUL === "true";

export const SaveClipFlow = () => {
  const vm = useSaveClipFlowViewModel();

  if (!SUBSCRIPTION_OVERHAUL) return null;

  const renderStep = () => {
    switch (vm.step) {
      case ESaveClipStep.CHECKING:
        return <Checking />;
      case ESaveClipStep.SUMMARY:
        return (
          <Summary
            clipTitle={vm.clipTitle}
            clipThumbnail={vm.clipThumbnail}
            storageStatus={vm.storageStatus}
            onSave={vm.handleSave}
            onCancel={vm.handleClose}
            isSaving={vm.savingClip}
            error={vm.saveError}
          />
        );
      case ESaveClipStep.SUCCESS:
        return (
          <Success
            clipTitle={vm.clipTitle}
            clipThumbnail={vm.clipThumbnail}
            storageStatus={vm.storageStatus}
            onDone={vm.handleClose}
          />
        );
      case ESaveClipStep.NO_STORAGE:
        return (
          <NoStorage
            storageStatus={vm.storageStatus}
            onManageClips={vm.handleManageClips}
            onCancel={vm.handleClose}
            manageMode={vm.manageMode}
          />
        );
      case ESaveClipStep.DELETE_BROWSE:
        return (
          <DeleteBrowse
            clips={vm.clipsForDeletion}
            isLoading={vm.savedClipsLoading}
            selectedClipIds={vm.selectedClipIds}
            onSelectClip={vm.handleSelectClip}
            onSortChange={vm.handleSortChange}
            currentSort={vm.currentSort}
            onDelete={vm.handleRemoveSelected}
            onBack={vm.handleBackFromDelete}
            isDeleting={vm.isDeleting}
            backButtonText="Back"
            onOpenClip={vm.handleOpenClip}
            actionLabel="Remove"
          />
        );
      default:
        return <Checking />;
    }
  };

  return (
    <Modal
      isModalOpen={vm.isOpen}
      setModalOpen={(open: boolean) => !open && vm.handleClose()}
      handleModalClose={undefined}
      disableOutsideClose={false}
    >
      <ModalContainer>
        <ModalHeader>
          <HeaderContent>
            <HeaderTitle>
              {vm.headerContent.clipName ? (
                <>
                  <span>{vm.headerContent.title.split(" ")[0]} </span>
                  <ClipName>{vm.headerContent.clipName}</ClipName>
                </>
              ) : (
                vm.headerContent.title
              )}
            </HeaderTitle>
            {vm.headerContent.subtitle && (
              <HeaderSubtitle>{vm.headerContent.subtitle}</HeaderSubtitle>
            )}
          </HeaderContent>
          <CloseButton onClick={vm.handleClose}>
            <HiX size={20} />
          </CloseButton>
        </ModalHeader>
        {renderStep()}
      </ModalContainer>
    </Modal>
  );
};
